import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import type { NeedsReviewIconProps } from "./types";

export const NeedsReviewIcon = ({ size = 16 }: NeedsReviewIconProps) => {
  const { t } = useTranslation();

  return (
    <span
      title={t("smartSurveyor.needsReviewBadge.tooltip")}
      className="inline-flex"
    >
      <AlertTriangle size={size} className="text-amber-600 shrink-0" />
    </span>
  );
};
